import { useState } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PrimaryButton, CheckBox } from 'ui_kit_qmd'

import { TreatmentItem } from './components/treatment-item/TreatmentItem'
import { HeaderView } from '../header-view/HeaderView'
import { useProductOrderContext } from '../../context'
import './productPayment.scss'
import './components/treatment-item/treatmentItem.scss'
import { formatHomeDeliveryAddress } from './utils'
import { ProductSelectedTile } from '../complete-product-order-view/components/product-selected-tile/ProductSelectedTile'
import { selectAsyncRefillsPhase1Flag } from 'store/flags/FlagsSelectors'
import { useSelector } from 'store/hooks/useSelector'

interface Props {
  onPlaceOrder: () => void
  accountCredit?: number
  onChange: () => void
}

export const ProductPayment = ({ onPlaceOrder, accountCredit = 0, onChange }: Props) => {
  const { deliveryType, note, orderInfo, isPharmacyPickup, isMHTHomeDelivery, isMHT, cartItems, getCartSubTotal } =
    useProductOrderContext()
  const asyncRefillsPhase1 = useSelector(selectAsyncRefillsPhase1Flag)
  const showProductTile = !isMHT || (isMHTHomeDelivery && asyncRefillsPhase1)

  const subtotal: number = cartItems.length ? Number(getCartSubTotal()) : Number(orderInfo?.Order?.Price ?? 0)

  const accountCreditToUse = Math.min(accountCredit, subtotal)
  const total: number = subtotal - accountCreditToUse

  const [hasAcknowledged, setHasAcknowledged] = useState(false)

  const buttonText = 'Create order'

  return (
    <div className='product-payment-popup-body-container product-selection-view-container'>
      <HeaderView title={total <= 0 ? 'Confirm order' : 'Complete order'} />

      <div className='product-selection-view-body-container' style={{ padding: 0 }}>
        <div className='product-payment-inner-container'>
          <div className='product-payment-popup-info-section'>
            {showProductTile ? <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {cartItems.map((cartItem) => (
                  <ProductSelectedTile key={cartItem.CartId} item={cartItem} onChange={onChange} />
                ))}
              </div> : null}
            <div className='product-payment-popup-info-container'>
              <div className='product-payment-popup-title-container'>
                <div className='product-payment-popup-title-text'>Description</div>
                <div className='product-payment-popup-title-text'>Fee</div>
              </div>
              <div className='product-payment-popup-treatment-container'>
                {cartItems.length ?
                  cartItems.map((item) => <TreatmentItem orderItem={item} />)
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                : <TreatmentItem orderItem={orderInfo} />}
              </div>
              <div className='product-payment-popup-item-container'>
                <div>Subtotal</div>
                <div>${Number(subtotal.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 })}</div>
              </div>
              {accountCreditToUse > 0 ?
                <div className='product-payment-popup-item-container'>
                  <div>Account credits</div>
                  <div>
                    -$
                    {Number(accountCreditToUse.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                  </div>
                </div>
              : null}
              <div className='product-payment-popup-item-container total'>
                <div>Total Due</div>
                <div>{`$${Number(total.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 })}`}</div>
              </div>
            </div>

            {!isPharmacyPickup && (
              <div className='product-payment-method-container'>
                <div className='product-payment-section-text'>Payment Method</div>
                <div className='product-payment-info-banner'>
                  <div className='product-payment-info-banner-content'>
                    <div className='product-payment-info-banner-title'>No payment collection needed</div>
                    <div className='product-payment-info-banner-text'>
                      The patient will be able to pay and order via the QuickMD patient app after the visit.
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='product-payment-footer-container'>
          {!isPharmacyPickup && (
            <>
              <div className='product-payment-section-text'>Delivery Details</div>
              {deliveryType === 'home' && (
                // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                <div className='product-payment-home-delivery-address'>{formatHomeDeliveryAddress(orderInfo)}</div>
              )}
              <CheckBox
                label='I have informed the patient that they will need to order the medications after the visit in the patient app.'
                isChecked={hasAcknowledged}
                setIsChecked={() => setHasAcknowledged((prev) => !prev)}
              />
            </>
          )}

          {note ?
            <>
              <div className='product-payment-section-text note-title'>Note for Pharmacy</div>
              <div className='product-payment-note-text' style={{ fontStyle: 'italic' }}>
                {note}
              </div>
            </>
          : null}
        </div>
      </div>
      <div className='product-selection-view-button-container'>
        <PrimaryButton
          useUpdatedStyle
          btnText={buttonText}
          containerStyle={{ width: '100%', height: 60 }}
          onPress={onPlaceOrder}
          disabled={!isPharmacyPickup && !hasAcknowledged}
        />
      </div>
    </div>
  )
}
